import React, { Component } from 'react';
import { StyleSheet, css } from '../../utility/paypalAphrodite';
import colors from '../../styles/colors';
import PropTypes from 'prop-types';
import { CURRENCY_CONVERSION_OPTIONS } from '../../pages/guest/crossBorder';
import { localsMessages } from '../../utility/getTemplateData';
import { Icon, Modal, Container, CaptionText } from '@paypalcorp/pp-react';
import Illustration from '../illustrations/Illustration';
const messages = localsMessages('guest/crossBorder');

const styles = StyleSheet.create({
  modal: {
    background: '#f4f6f9',
    height: '100%',
  },
  modalDialog: {
    background: 'white',
    height: '100%',
    marginTop: 0,
    marginBottom: 0,
    width: 696,
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
  // Currency Conversion
  modalTitle: {
    marginTop: 0,
    fontSize: 30,
    fontWeight: 300,
    marginBottom: 14,
  },
  optionTitle: {
    color: colors.linkBlue,
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: 1.33,
    textAlign: 'center',
  },

  optionDetails: {
    textAlign: 'center',
  },
  bodyText: {
    fontSize: '15px',
    color: '#2c2e2f',
    margin: 0,
  },
  boldText: {
    fontWeight: 500,
  },
  icon: {
    height: 34,
    width: 34,
  },
  closeBtn: {
    fontSize: 32,
    color: '#444444',
  },
  iconCustom: {
    ':before': {
      fontSize: '4rem',
    },
    color: '#00c99c',
  },
  conversionOption: {
    opacity: 0,
    position: 'absolute',
    ':focus + label': {
      outline: [
        'hsl(216, 91%, 69%) auto 5px',
        '-webkit-focus-ring-color auto 5px',
      ],
    },
  },
});

const SuccessCheckmarkIcon = (props) => {
  return (
    <div className="highlighted-option">
      <Icon className="highlight-icon" name="check-circle-alt" size="md" />
    </div>
  );
};

const CurrencyConversionOption = (props) => {
  return (
    <div>
      <input
        type="checkbox"
        id={props.type}
        value={props.type}
        className={`${css(styles.conversionOption)}`}
        checked={props.isSelected}
        onChange={() => props.handleOptionSelection(props.type)}
      />
      <label htmlFor={props.type}>
        <div
          className={`currency-conversion-option ${
            props.isSelected ? 'option-selected' : ''
          }`}
          onClick={() => props.handleOptionSelection(props.type)}
        >
          {props.isSelected && <SuccessCheckmarkIcon />}

          <div className="option-icon-container text-center">
            {props.icon && (
              <Icon
                className="option-icon paypal-color"
                name={props.icon}
                size="xl"
              />
            )}
            {props.illustration && <Illustration type={props.illustration} />}
            {props.src && (
              <img
                src={props.src}
                alt="paypal-logo"
                style={{ width: '144px' }}
              ></img>
            )}
          </div>
          <div className="options-container text-center">
            <CaptionText
              className="option-title"
              strong
              style={{ marginBottom: '14px' }}
            >
              {props.title}
            </CaptionText>
            <div className="option-details">
              {props.rate && <CaptionText strong>{props.rate}</CaptionText>}
              <CaptionText as="span">{props.description}</CaptionText>
            </div>
          </div>
        </div>
      </label>
      <div style={{ height: '25px' }}></div>
    </div>
  );
};

CurrencyConversionOption.propTypes = {
  isSelected: PropTypes.bool,
  type: PropTypes.string,
  icon: PropTypes.string,
  illustration: PropTypes.string,
  title: PropTypes.string,
  rate: PropTypes.string,
  description: PropTypes.string,
  src: PropTypes.string,
};

class CurrencyConversionModal extends Component {
  handleOptionSelection = (option) => {
    this.props.handleOptionSelection(option);
  };

  handleClose = () => {
    this.props.hideModal();
  };

  render() {
    const { label } = messages;
    const { selectedOption, exchangeRate } = this.props;
    const isPayPalSelected =
      selectedOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL;

    return (
      <Modal
        className="recurring-signup-overpanel"
        overpanel
        title=""
        isOpen={this.props.isOpen}
        onClose={this.handleClose}
        hideLogo
        closeOnBackgroundClick={false}
      >
        <div className="modal-body currency-conversion">
          <Container>
            <div style={{ height: '70px' }}></div>
            <div className="ppvx_row">
              <div className="ppvx_col-12">
                <h2 className={`${css(styles.modalTitle)} } text-center`}>
                  {label.modalTitle}
                </h2>
              </div>
            </div>
            <div className="ppvx_row">
              <div className="ppvx_col-12">
                <p className={`${css(styles.bodyText)} text-center `}>
                  {label.modalSubTitle}
                </p>
              </div>
            </div>
            <div style={{ height: '40px' }}></div>
            <div>
              <CurrencyConversionOption
                isSelected={isPayPalSelected}
                src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-mark-color.svg"
                type={CURRENCY_CONVERSION_OPTIONS.PAYPAL}
                title={label.withPaypal.title}
                rate={`${label.withPayPal.rate}: ${exchangeRate}`}
                description={label.withPayPal.message}
                handleOptionSelection={this.handleOptionSelection}
              />
              <CurrencyConversionOption
                isSelected={!isPayPalSelected}
                illustration={'credit-cards'}
                type={CURRENCY_CONVERSION_OPTIONS.ISSUER}
                title={label.withCard.title}
                description={label.withCard.message}
                handleOptionSelection={this.handleOptionSelection}
              />
            </div>
          </Container>
        </div>
      </Modal>
    );
  }

  render2() {
    const { label } = messages;
    const { selectedOption, exchangeRate } = this.props;
    const isPayPalSelected =
      selectedOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL;

    return (
      <div
        className={`currency-conversion modal donate_dialog fade ${css(
          styles.modal
        )}`}
        data-tabindex="-1"
        data-role="dialog"
        id="currencyConversion"
        data-backdrop="static"
      >
        <div className={`modal-dialog ${css(styles.modalDialog)}`}>
          <div className="modal-content">
            {this.renderCloseButton()}
            <div style={{ height: '70px' }}></div>

            <div className="modal-body">
              <h2 className={`${css(styles.modalTitle)} } text-center`}>
                {label.modalTitle}
              </h2>
              <p className={`${css(styles.bodyText)} text-center `}>
                {label.modalSubTitle}
              </p>
              <div style={{ height: '40px' }}></div>

              <div>
                <CurrencyConversionOption
                  isSelected={isPayPalSelected}
                  src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-mark-color.svg"
                  type={CURRENCY_CONVERSION_OPTIONS.PAYPAL}
                  title={label.withPaypal.title}
                  rate={`${label.withPayPal.rate}: ${exchangeRate}`}
                  description={label.withPayPal.message}
                  handleOptionSelection={this.handleOptionSelection}
                />
                <CurrencyConversionOption
                  isSelected={!isPayPalSelected}
                  illustration={'credit-cards'}
                  type={CURRENCY_CONVERSION_OPTIONS.ISSUER}
                  title={label.withCard.title}
                  description={label.withCard.message}
                  handleOptionSelection={this.handleOptionSelection}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CurrencyConversionModal.propTypes = {
  handleOptionSelection: PropTypes.func.isRequired,
  hideModal: PropTypes.func,
  selectedOption: PropTypes.string,
  exchangeRate: PropTypes.string,
  isOpen: PropTypes.bool,
};

export default CurrencyConversionModal;
